import { StyleFn } from './index'

export type StylesKeys =
  | 'trackDetails'
  | 'trackDetailsImg'
  | 'trackDetailsText'
  | 'trackDetailsTextArtist'
  | 'trackDetailsTextName'

export type StylesObj = {
  [key in StylesKeys]?: StyleFn
}

export type Styles = {
  trackDetails: StyleFn
  trackDetailsImg: StyleFn
  trackDetailsText: StyleFn
  trackDetailsTextArtist: StyleFn
  trackDetailsTextName: StyleFn
}

export const defaultStyles: Styles = {
  trackDetails: () => ({
    gridArea: 'det',
  }),
  trackDetailsImg: () => ({
    width: '20%',
    height: 'auto',
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: '0.8em',
    borderRadius: '4px',
    maxWidth: '3em',
    color: '#292b2f',
  }),
  trackDetailsText: () => ({
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingTop: '4px',
  }),
  trackDetailsTextArtist: () => ({
    fontSize: '1em',
    fontWeight: 800,
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  trackDetailsTextName: () => ({
    fontSize: '0.9em',
    fontWeight: 800,
    color: 'var(--rw-accent)',
    margin: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),
}
